<template>
  <div class="faqs w-full mx-auto flex flex-col gap-12 lg:gap-20" v-if="component.faqs">
    <div class="faqs__list">
      <Faq
        class="faqs__item border-t border-christine"
        :class="{ 'border-b lg:border-b-0': index === component.faqs.length - 1 }"
        v-for="(faq, index) in component.faqs"
        :key="index"
        :faq="faq"
      />
    </div>

    <div class="faqs__cta flex flex-col items-start">
      <h2 class="h4 mb-3">{{ t('components.faqs.cta.title') }}</h2>
      <p>{{ t('components.faqs.cta.description') }}</p>
      <SharedButton :label="t('components.faqs.cta.label')" variant="secondary" class="w-max mt-6" :to="useLocalizedPath(siteOptions?.data?.contactPage?.slug || '')" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { WithTypename } from '~/types/graphql';
  import type { FAQs } from '~/types/strapi';
  import type { StrapiResponse, SiteOption } from '~/types/strapi';
  import Faq from './Faq.vue';

  const { t } = useI18n();

  const siteOptions = inject('siteOptions') as Ref<StrapiResponse<SiteOption>> | undefined;

  defineProps<{
    component: WithTypename<FAQs>;
  }>();
</script>

<style lang="scss">
  .page.page--vehicle-detail {
    .content-section:has(.faqs) {
      @apply print:hidden;
    }
  }
</style>
